import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  Renderer2,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import Renderer2Helpers from '../../../campaign/widget-editor/widget-editor-canvas/components/renderer2-helpers';
import { RgbColor } from '../color-picker.component';

@Component({
  selector: 'app-opacity-slider',
  templateUrl: './opacity-slider.component.html',
  styleUrls: ['./opacity-slider.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OpacitySliderComponent {
  private _rgbColor: RgbColor;
  public _opacity: number;
  public opacityTimes100 = 100;

  @Input() set rgbColor(rgbColor: RgbColor) {
    this._rgbColor = rgbColor;
    this.parseBackgroundOnSlider();
  }

  @Input() public set opacity(opacity: number) {
    this._opacity = opacity;
    if (opacity !== undefined) {
      this.opacityTimes100 = Math.round(100 * this._opacity);
    }
  }
  public get opacity(): number {
    return this._opacity;
  }

  @Output() opacityUpdated: EventEmitter<number> = new EventEmitter();

  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef,
  ) {}

  private parseBackgroundOnSlider() {
    if (this._rgbColor) {
      const startColor = `rgba(${this._rgbColor.r}, ${this._rgbColor.g}, ${this._rgbColor.b}, 1)`;
      const endColor = `rgba(${this._rgbColor.r}, ${this._rgbColor.g}, ${this._rgbColor.b}, 0)`;
      const background = `linear-gradient(to left, ${startColor}, ${endColor}), url("/assets/img/campaign/canvas_small.png") 100% 100%`;
      this.renderer.setStyle(
        this.elementRef.nativeElement.querySelector('.mdc-slider__track'),
        'background',
        background,
        Renderer2Helpers.FlagsBugfixValue,
      );
    }
  }

  public emitOpacityChange() {
    this._opacity = this.opacityTimes100 / 100;
    this.opacityUpdated.emit(this._opacity);
  }
}
